import { Box, Grid, Typography } from "@mui/material";
import React from "react";

interface Props {
  saleDate: string;
  factorNumber: string;
  gatewayToken: string;
  onlinePaymentInformation: {
    purchaseBasketKey: string;
    gatewayTitle: string;
    cashPaymentAmount: number;
    transactionNumber: string;
    trackingNumber: string;
  };
}

const PaymentDetail = ({
  factorNumber,
  onlinePaymentInformation,
  saleDate,
  gatewayToken,
}: Props) => {
  return (
    <Grid
      container
      sx={{ padding: { xs: "30px 0px", md: "30px 20px" } }}
      gap={"20px"}
    >
      {/* top section */}
      <Grid
        item
        xs={12}
        width={"100%"}
        sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
      >
        {saleDate && (
          <Box
            sx={{ display: "flex", justifyContent: "space-between" }}
            width={"100%"}
          >
            <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
              تاریخ فروش:
            </Typography>
            <Typography sx={{ fontSize: ".9rem", color: "#34495E" }}>
              <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "#FB8C00",
                }}
              >
                {saleDate}
              </span>{" "}
            </Typography>
          </Box>
        )}
        {factorNumber && (
          <Box
            sx={{ display: "flex", justifyContent: "space-between" }}
            width={"100%"}
          >
            <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
              شماره فاکتور فروش:
            </Typography>
            <Typography
              sx={{ fontSize: ".9rem", color: "#34495E", direction: "ltr" }}
            >
              {factorNumber}
            </Typography>
          </Box>
        )}
        {gatewayToken && (
          <Box
            sx={{ display: "flex", justifyContent: "space-between" }}
            width={"100%"}
          >
            <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
              شناسه پرداخت:
            </Typography>
            <Typography
              sx={{ fontSize: ".9rem", color: "#34495E", direction: "ltr" }}
            >
              {gatewayToken}
            </Typography>
          </Box>
        )}
      </Grid>
      {/* bottom section */}
      {onlinePaymentInformation ? (
        <Grid
          item
          xs={12}
          sx={{
            borderTop: "2px dashed #DAE0E4",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            paddingTop: "20px",
          }}
        >
          <Typography
            sx={{ color: "#1D4A87", fontSize: "1rem", fontWeight: "600" }}
          >
            اطلاعات درگاه پرداخت
          </Typography>
          {onlinePaymentInformation?.purchaseBasketKey && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between" }}
              width={"100%"}
            >
              <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
                شناسه سبد خرید:{" "}
              </Typography>
              <Typography
                sx={{ fontSize: ".9rem", color: "#34495E", direction: "ltr" }}
              >
                {onlinePaymentInformation?.purchaseBasketKey}
              </Typography>
            </Box>
          )}
          {onlinePaymentInformation?.gatewayTitle && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between" }}
              width={"100%"}
            >
              <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
                درگاه پرداخت نقدی:{" "}
              </Typography>
              <Typography sx={{ fontSize: ".9rem", color: "#34495E" }}>
                {onlinePaymentInformation?.gatewayTitle}
              </Typography>
            </Box>
          )}
          {onlinePaymentInformation?.cashPaymentAmount && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between" }}
              width={"100%"}
            >
              <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
                مبلغ پرداخت نقدی:{" "}
              </Typography>
              <Typography sx={{ fontSize: ".9rem", color: "#34495E" }}>
                <span style={{ fontSize: ".9rem" }}>
                  {onlinePaymentInformation?.cashPaymentAmount?.toLocaleString(
                    "fa"
                  )}
                </span>{" "}
                ریال
              </Typography>
            </Box>
          )}
          {onlinePaymentInformation?.transactionNumber && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between" }}
              width={"100%"}
            >
              <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
                شماره تراکنش:{" "}
              </Typography>
              <Typography sx={{ fontSize: ".9rem", color: "#34495E" }}>
                {onlinePaymentInformation?.transactionNumber}
              </Typography>
            </Box>
          )}
          {onlinePaymentInformation?.trackingNumber && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between" }}
              width={"100%"}
            >
              <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
                شماره پیگیری:{" "}
              </Typography>
              <Typography sx={{ fontSize: ".9rem", color: "#34495E" }}>
                {onlinePaymentInformation?.trackingNumber}
              </Typography>
            </Box>
          )}
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          sx={{
            borderTop: "2px dashed #DAE0E4",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            paddingTop: "20px",
          }}
        >
          <Typography
            sx={{ color: "#1D4A87", fontSize: "1rem", fontWeight: "600" }}
          >
            اطلاعات درگاه پرداخت
          </Typography>
          <Typography sx={{ fontSize: ".9rem", color: "#9AAFC4" }}>
            فروش از نوع "حضوری" بوده است و تراکنشی در درگاه پرداخت آنلاین انجام
            نشده است.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default PaymentDetail;
